import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../direct/DismissBackground.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../NativeElement.mjs';
import {
  get_centered31th09q7x90sf as get_centered,
  get_atBottomCenter25gz8knna6ld8 as get_atBottomCenter,
} from '../helpers.mjs';
import { beforeSetupw9y6lebwkk6y as beforeSetup } from '../ElementWriter.ext.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { overlayt2e94k47ee8y as overlay } from '../ViewContextExtensions.commonHtml.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
  _Duration___get_inWholeMilliseconds__impl__msfiry33sjnw92ish9p as _Duration___get_inWholeMilliseconds__impl__msfiry,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { text189ciz0cnr32o as text } from '../direct/shortcuts.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../direct/LinearLayouts.commonHtml.mjs';
import { get_native16zxqjg6lrtlz as get_native } from '../NativeElement.commonHtml.mjs';
import {
  get_animationsEnabled25ujr8oia8gbs as get_animationsEnabled,
  set_animationsEnabled1ac1lbh50s602 as set_animationsEnabled,
} from '../Element.ext.js.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../models/data.commonHtml.mjs';
import {
  PopoverSemantic_getInstanceyx37zl2h0qnj as PopoverSemantic_getInstance,
  DialogSemantic_getInstance1e2v1jwywf0uw as DialogSemantic_getInstance,
} from '../../models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../themeDerivations.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../direct/Space.commonHtml.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { get_theme90wn9glxu60a as get_theme } from '../Element.ext.mjs';
import {
  delayp0o4nsccwai as delay,
  delay2kng7ucb3aj62 as delay_0,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function dialog(_this__u8e3s4, dismissable, content) {
  dismissable = dismissable === VOID ? true : dismissable;
  overlay(_this__u8e3s4, true, dismissable, VOID, ($this$overlay, close) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (DismissBackground())($this$overlay.get_context_h02k06_k$());
    ensureOutermostElement(element);
    $this$overlay.willAddChild_hz2iwc_k$(element);
    element.set_debugName_wihv62_k$('dialog-bg');
    element.onClick_tk88x3_k$(dialog$lambda$slambda(dismissable, close));
    var tmp = get_centered(element);
    content(beforeSetup(tmp, dialog$lambda$lambda), close);
    element.onStartup_vrxh3i_k$();
    $this$overlay.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
}
function toast(_this__u8e3s4, text_0, duration) {
  var tmp;
  if (duration === VOID) {
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    tmp = toDuration(3, DurationUnit_SECONDS_getInstance());
  } else {
    tmp = duration;
  }
  duration = tmp;
  toast_0(_this__u8e3s4, duration, ($this$toast) => {
    text($this$toast, text_0);
    return Unit_instance;
  });
}
function toast_0(_this__u8e3s4, duration, content) {
  var tmp;
  if (duration === VOID) {
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    tmp = toDuration(3, DurationUnit_SECONDS_getInstance());
  } else {
    tmp = duration;
  }
  duration = tmp;
  overlay(_this__u8e3s4, false, VOID, VOID, ($this$overlay, it) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_0 = get_atBottomCenter($this$overlay);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element);
    this_0.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(true);
    // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
    var tmp = get_native(element).element_1;
    var tmp0_safe_receiver = tmp instanceof HTMLElement ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
      var this_1 = tmp0_safe_receiver;
      var animate = get_animationsEnabled();
      try {
        if (animate) {
          set_animationsEnabled(false);
          // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp_1 = this_1.__suppressMutationObserverClass;
          var tmp0_elvis_lhs = tmp_1 instanceof ArrayList() ? tmp_1 : null;
          var tmp_2;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.run' call
            var n = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
            // Inline function 'kotlin.js.asDynamic' call
            this_1.__suppressMutationObserverClass = n;
            tmp_2 = n;
          } else {
            tmp_2 = tmp0_elvis_lhs;
          }
          var e = tmp_2;
          this_1.classList.add('notransition');
          var tmp1_elvis_lhs = this_1.getAttribute('class');
          e.add_utx5q5_k$(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
        }
        element.set_opacity_ecw914_k$(0.0);
        launch(element, VOID, VOID, toast$lambda$slambda(element, duration, $this$overlay));
        element.set_gap_jwjroq_k$(get_rem(2));
        content(themed(element, PopoverSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (Space())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
      }finally {
        if (animate) {
          var tmp_3 = window;
          tmp_3.setTimeout(() => {
            // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
            var this_0 = this_1;
            // Inline function 'kotlin.js.asDynamic' call
            var tmp = this_0.__suppressMutationObserverClass;
            var tmp0_elvis_lhs = tmp instanceof ArrayList() ? tmp : null;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              // Inline function 'kotlin.run' call
              var n = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
              // Inline function 'kotlin.js.asDynamic' call
              this_0.__suppressMutationObserverClass = n;
              tmp_0 = n;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            var e = tmp_0;
            this_1.classList.remove('notransition');
            var tmp1_elvis_lhs = this_0.getAttribute('class');
            e.add_utx5q5_k$(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
            return Unit_instance;
          }, 100);
          set_animationsEnabled(true);
        }
      }
      tmp_0 = Unit_instance;
    }
    if (tmp_0 == null) {
      element.set_opacity_ecw914_k$(0.0);
      launch(element, VOID, VOID, toast$lambda$slambda_0(element, duration, $this$overlay));
      element.set_gap_jwjroq_k$(get_rem(2));
      content(themed(element, PopoverSemantic_getInstance()));
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_1 = new (Space())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_1);
      element.willAddChild_hz2iwc_k$(element_1);
      element_1.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_1);
    }
    element.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
}
function dialog$lambda$slambda($dismissable, $close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    if ($dismissable)
      $close();
    return Unit_instance;
  }), 0);
}
function dialog$lambda$lambda($this$beforeSetup) {
  $this$beforeSetup.set_debugName_wihv62_k$('dialog');
  $this$beforeSetup.set_themeChoice_py59um_k$($this$beforeSetup.get_themeChoice_22tyn3_k$().plus_duvq05_k$(DialogSemantic_getInstance()));
  return Unit_instance;
}
function toast$lambda$slambda($$this$col, $duration, $this_overlay) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    var t = get_theme($$this$col);
    yield* delay(1n, $completion);
    $$this$col.set_opacity_ecw914_k$(1.0);
    yield* delay(_Duration___get_inWholeMilliseconds__impl__msfiry($duration), $completion);
    $$this$col.set_opacity_ecw914_k$(0.0);
    yield* delay_0(t.transitionDuration_1, $completion);
    $this_overlay.removeChild_kofmvd_k$($$this$col);
    return Unit_instance;
  }), 1);
}
function toast$lambda$slambda_0($$this$col, $duration, $this_overlay) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    var t = get_theme($$this$col);
    yield* delay(1n, $completion);
    $$this$col.set_opacity_ecw914_k$(1.0);
    yield* delay(_Duration___get_inWholeMilliseconds__impl__msfiry($duration), $completion);
    $$this$col.set_opacity_ecw914_k$(0.0);
    yield* delay_0(t.transitionDuration_1, $completion);
    $this_overlay.removeChild_kofmvd_k$($$this$col);
    return Unit_instance;
  }), 1);
}
//region block: exports
export {
  dialog as dialog3sxbjr735jrum,
  toast as toast4hp3bb4ymp24,
};
//endregion

//# sourceMappingURL=popoverHelpers.mjs.map
